import React from 'react';

import CardIssuerLogo from 'Jsx/Shared/CardIssuerLogo';

const CardLabel = (cardNumber?: number | null) =>
  cardNumber ? (
    <div className="flex items-center justify-start">
      <CardIssuerLogo cardType="Visa" />
      <span className="ml-12">
        &#x25CF;&#x25CF;&#x25CF;&#x25CF; &nbsp; &#x25CF;&#x25CF;&#x25CF;&#x25CF;
        &nbsp; &#x25CF;&#x25CF;&#x25CF;&#x25CF;
      </span>
      <span className="font-body4 ml-12 tw-font-semibold">{cardNumber}</span>
    </div>
  ) : undefined;

export default CardLabel;
